module.exports = __webpack_public_path__ + "img/sony-logo-screenshot.png";